import { render, staticRenderFns } from "./EconomicActivity.vue?vue&type=template&id=37f6fe22"
import script from "./EconomicActivity.vue?vue&type=script&lang=js"
export * from "./EconomicActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports